import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import InvestorPortalLayout from '../../../components/market/InvestorPortalLayout';
import { useInvestorAuth } from '../../../context/InvestorAuthContext';
import { Icon } from '../../../utils/icons';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const STATUS_STYLE = {
  submitted:    { bg: '#f3f4f6', color: '#374151', label: 'Bid submitted' },
  loi_pending:  { bg: '#fffbeb', color: '#92400e', label: 'LOI pending' },
  loi_signed:   { bg: '#eff3fe', color: '#3a6ad9', label: 'LOI signed' },
  dd_open:      { bg: '#f0fde4', color: '#166534', label: 'DD room open' },
  accepted:     { bg: '#f0fde4', color: '#166534', label: 'Accepted' },
  rejected:     { bg: '#fff5f6', color: '#ff082f', label: 'Not selected' },
  withdrawn:    { bg: '#f3f4f6', color: '#6b7280', label: 'Withdrawn' },
};

const fmt$ = (n) => n == null ? '—' : `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export default function InvestorPortalBids() {
  const { token } = useInvestorAuth();
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await axios.get(`${API_URL}/api/market/bids`, { headers: { Authorization: `Bearer ${token}` } });
        if (!mounted) return;
        setBids(r.data?.bids || []);
      } catch {} finally { if (mounted) setLoading(false); }
    })();
    return () => { mounted = false; };
  }, [token]);

  return (
    <InvestorPortalLayout>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#111111' }}>My Bids</h1>
        <p style={{ margin: '4px 0 22px', fontSize: 13, color: '#6b7280' }}>
          Your bid activity across DoorlyMarket pools.
        </p>

        {loading ? (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 60, textAlign: 'center', color: '#9ca3af' }}>Loading bids…</div>
        ) : bids.length === 0 ? (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 40, textAlign: 'center' }}>
            <div style={{ width: 56, height: 56, margin: '0 auto 12px', borderRadius: 12, background: '#eff3fe', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon name="list" size={26} color="#3a6ad9" />
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#111111', marginBottom: 4 }}>No bids yet</div>
            <div style={{ fontSize: 13, color: '#6b7280' }}>
              You'll see your bid activity here once you submit a bid on a pool.
            </div>
          </div>
        ) : (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f9fafb' }}>
                  {['Pool', 'Bid Amount', 'Bid Price', 'Status', 'Submitted'].map((h) => (
                    <th key={h} style={{ textAlign: 'left', padding: '10px 14px', fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4, borderBottom: '1px solid #e5e7eb' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {bids.map((b) => {
                  const cfg = STATUS_STYLE[b.status] || STATUS_STYLE.submitted;
                  return (
                    <tr key={b.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      <td style={{ padding: '12px 14px' }}>
                        <Link to={`/market/bids/${b.id}/dd-room`} style={{ color: '#111111', fontWeight: 600, textDecoration: 'none' }}>
                          {b.pool_name || b.pool_number || `Bid #${b.id}`}
                        </Link>
                        {b.pool_number && <div style={{ fontSize: 11, color: '#9ca3af' }}>{b.pool_number}</div>}
                      </td>
                      <td style={{ padding: '12px 14px', color: '#111111', fontVariantNumeric: 'tabular-nums' }}>{fmt$(b.bid_amount)}</td>
                      <td style={{ padding: '12px 14px', color: '#374151', fontVariantNumeric: 'tabular-nums' }}>
                        {b.bid_price_pct != null ? `${Number(b.bid_price_pct).toFixed(2)}%` : '—'}
                      </td>
                      <td style={{ padding: '12px 14px' }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: cfg.color, background: cfg.bg, padding: '4px 10px', borderRadius: 999 }}>
                          {cfg.label}
                        </span>
                      </td>
                      <td style={{ padding: '12px 14px', color: '#6b7280' }}>
                        {b.submitted_at ? new Date(b.submitted_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </InvestorPortalLayout>
  );
}
